interface MobileMenuItemProps {
  label: string;
  onClick?: () => void;
  className?: string;
}

export function MobileMenuItem({ label, onClick, className = "" }: MobileMenuItemProps) {
  return (
    <div className={`mobile-menu-item ${className}`} onClick={onClick} role="button" tabIndex={0}>
      {label}
    </div>
  );
}
